import { useEffect, useRef, useState } from "react";
import "./App.css";
import { ApiRefreshProvider } from "./Component/ApiRefreshContext";
import { RenderRout } from "./router";
import db from "./firebase";
import { onValue, ref } from "firebase/database";
import { useSelector } from "react-redux";
import BirthdayPopup from "./Component/Pages/Wishing/BirthdayPopup";
import Anniversarypopup from "./Component/Pages/Wishing/Anniversarypopup";

function App() {
  const users = useSelector((state) => state.UserProfile.profile);
  const user = JSON.parse(localStorage.getItem("userData"));
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const notifRef = ref(
      db,
      `notifications/${users?.id ? users?.id : user?.id}`
    );

    const unsubscribe = onValue(notifRef, (snap) => {
      const data = snap.val() || {};
      const list = Object.entries(data)
        .map(([key, val]) => ({ ...val, firebaseKey: key }))
        .sort(
          (a, b) =>
            (b.createdAt ?? b.timestamp ?? 0) -
            (a.createdAt ?? a.timestamp ?? 0)
        );

      setNotifications(list);
    });

    return () => unsubscribe();
    // eslint-disable-next-line
  }, [users?.id, user?.id]);

  const unread = notifications.filter((n) => !n.isReaded).length;

  const originalHref = useRef(null);

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) return;

    if (!originalHref.current) originalHref.current = link.href;

    if (unread === 0) {
      link.href = originalHref.current; // restore original icon
      return;
    }

    // Draw badge
    const size = 32;
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.src = originalHref.current;

    img.onload = () => {
      ctx.drawImage(img, 0, 0, size, size);

      // red circle
      ctx.fillStyle = "#F44336";
      ctx.beginPath();
      ctx.arc(size - 8, 8, 8, 0, 2 * Math.PI);
      ctx.fill();

      // count
      ctx.fillStyle = "#fff";
      ctx.font = "bold 10px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(unread > 99 ? "99+" : unread.toString(), size - 8, 8);

      link.href = canvas.toDataURL("image/png");
    };
  }, [unread]);


  

  return (
    <ApiRefreshProvider>
      <BirthdayPopup />
<Anniversarypopup/>
      <RenderRout />
    </ApiRefreshProvider>
  );
}

export default App;
